import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import dates from 'react-big-calendar/lib/utils/dates'
import BigCalendar from 'react-big-calendar'
import * as instructorActions from '../../_actions/roster.actions'
import { mergeWithDefaults } from 'react-big-calendar/lib/localizer'
import { Card } from 'antd'
import ToolbarSummary from './ToolbarSummary'
import { ResponsiveBar } from '@nivo/bar'
import _ from 'lodash'
import { navigate } from './constants'
import BrancheSelect from '../common/BrancheSelect'
import DepartmentSelect from '../common/DepartmentSelect'
import { reports } from './constants'
import { viewConstants } from '../../_constants/view.constants'
import { reportService } from '../../_services/report.service'

const moment = require('moment')
const _localizer = BigCalendar.momentLocalizer(moment)
const localizer = mergeWithDefaults(_localizer, 'en-NZ', {}, {})

class OverviewReport extends Component {
    static defaultProps = {
        getNow: () => new Date(),
    }
    state = {
        selectedBranch: {},
        selectedDepartment: {},
        defaultRange: [],
        currentDate: new Date(),
        events: [],
    }

    componentDidMount = async () => {
        const defaultRange = this.range(this.props.getNow())
        // transform events
        const options = {
            range: viewConstants.MONTH,
            time: this.props.getNow(),
        }
        // this.props.actions.updateSummaryReportEvents(options);

        // const rosters = await rosterService.fetchETime(options)
        // const leaves = await employeeLeaveService.fetchEmployeeLeave(options)

        const graphData = await reportService.updateSummaryReportEvents(options)

        this.setState({ current: defaultRange, events: graphData })
    }

    range = date => {
        var firstOfMonth = dates.startOf(date, 'month')
        var endOfMonth = dates.endOf(date, 'month')

        return dates.range(firstOfMonth, endOfMonth)
    }

    // range = date => {
    //     let firstOfWeek = localizer.startOfWeek()
    //     let start = dates.startOf(date, 'week', firstOfWeek)
    //     let end = dates.endOf(date, 'week', firstOfWeek)

    //     return dates.range(start, end)
    // }

    handleRangeChange = async date => {
        const range = this.range(date)
        const options = {
            range: viewConstants.MONTH,
            time: date,
        }

        const graphData = await reportService.updateSummaryReportEvents(options)

        this.setState({ current: range, currentDate: date, events: graphData })

        // this.setState({ current: range, currentDate: date })
    }

    handleBranchChange = branch => {
        const { selectedDepartment } = this.state
        let filterCond = {}
        if (branch.value !== 'all') {
            filterCond.branch = branch.value
        }
        if (selectedDepartment.value && selectedDepartment.value !== 'all') {
            filterCond.department = selectedDepartment.value
        }
        filterCond.view = reports.SUMMARY
        filterCond.time = this.state.currentDate
        filterCond.range = viewConstants.MONTH
        this.props.actions.updateSummaryReportDisplayEvents(filterCond)
        this.setState({
            selectedBranch: branch,
        })
    }

    handleDepartmentChange = department => {
        const { selectedBranch } = this.state

        let filterCond = {}
        if (department.value !== 'all') {
            filterCond.department = department.value
        }
        if (selectedBranch.value && selectedBranch.value !== 'all') {
            filterCond.branch = selectedBranch.value
        }
        filterCond.view = reports.SUMMARY
        filterCond.time = this.state.currentDate
        filterCond.range = viewConstants.MONTH

        this.props.actions.updateSummaryReportDisplayEvents(filterCond)
        this.setState({
            selectedDepartment: department,
        })
    }

    handleNavigate = (action, newDate) => {
        const currentDate = this.state.currentDate

        switch (action) {
            case navigate.PREVIOUS:
                // const previousMonth = dates.subtract(currentDate, 1, 'month')
                this.handleRangeChange(newDate)
                break
            case navigate.NEXT:
                // const nextMonth = dates.add(currentDate, 1, 'month')
                this.handleRangeChange(newDate)
                break
            case navigate.TODAY:
                this.handleRangeChange(new Date())
                break
            case navigate.DATE:
                this.handleRangeChange(newDate)
                break
            default:
        }
    }

    render() {
        return (
            <div>
                <div className="row">
                    {/* <div className="col-sm-3">
            <div className="reportToolBar">
              <BrancheSelect handleChange={this.handleBranchChange.bind(this)} />
            </div>
          </div>
          <div className="col-sm-3">
            <div className="reportToolBar">
              <DepartmentSelect
                handleChange={this.handleDepartmentChange.bind(this)}
              />
            </div>
          </div> */}
                    <div className="col-sm-6">
                        <ToolbarSummary
                            onNavigate={this.handleNavigate}
                        />
                    </div>
                </div>
                <div className="site-card-border-less-wrapper">
                    <Card title="Overview" bordered={false}>
                        <div style={{ height: 400 }}>
                            <ResponsiveBar
                                data={this.state.events}
                                keys={['leave', 'work']}
                                indexBy="date"
                                margin={{
                                    top: 50,
                                    right: 130,
                                    bottom: 50,
                                    left: 60,
                                }}
                                padding={0.3}
                                colors={{ scheme: 'nivo' }}
                                defs={[
                                    {
                                        id: 'dots',
                                        type: 'patternDots',
                                        background: 'inherit',
                                        color: '#38bcb2',
                                        size: 4,
                                        padding: 1,
                                        stagger: true,
                                    },
                                    {
                                        id: 'lines',
                                        type: 'patternLines',
                                        background: 'inherit',
                                        color: '#eed312',
                                        rotation: -45,
                                        lineWidth: 6,
                                        spacing: 10,
                                    },
                                ]}
                                borderColor={{
                                    from: 'color',
                                    modifiers: [['darker', 1.6]],
                                }}
                                axisTop={null}
                                axisRight={null}
                                axisBottom={{
                                    tickSize: 5,
                                    tickPadding: 5,
                                    tickRotation: 0,
                                    legend: `Period: ${moment(
                                        this.state.currentDate
                                    ).format('MMM YYYY')}`,
                                    legendPosition: 'middle',
                                    legendOffset: 32,
                                }}
                                axisLeft={{
                                    tickSize: 5,
                                    tickPadding: 5,
                                    tickRotation: 0,
                                    legend: 'Head count',
                                    legendPosition: 'middle',
                                    legendOffset: -40,
                                }}
                                labelSkipWidth={12}
                                labelSkipHeight={12}
                                labelTextColor={{
                                    from: 'color',
                                    modifiers: [['darker', 3]],
                                }}
                                legends={[
                                    {
                                        dataFrom: 'keys',
                                        anchor: 'bottom-right',
                                        direction: 'column',
                                        justify: false,
                                        translateX: 120,
                                        translateY: 0,
                                        itemsSpacing: 2,
                                        itemWidth: 100,
                                        itemHeight: 20,
                                        itemDirection: 'left-to-right',
                                        itemOpacity: 0.85,
                                        symbolSize: 20,
                                        effects: [
                                            {
                                                on: 'hover',
                                                style: {
                                                    itemOpacity: 1,
                                                },
                                            },
                                        ],
                                    },
                                ]}
                                animate={true}
                                motionStiffness={90}
                                motionDamping={15}
                            />
                        </div>
                    </Card>
                </div>
            </div>
        )
    }
}
function mapStateToProps(state) {
    return {
        events: state.roster.displaySummaryReportEvents,
        employees: state.roster.employeeList,
        selectedEmployee: state.roster.selectedEmployee,
        branches: state.BranchReducer.branchList,
        departments: state.DepartmentReducer.departmentList,
        actionTypes: state.ActionTypesReducer.actionTypes,
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(instructorActions, dispatch) }
}
export default connect(mapStateToProps, mapDispatchToProps)(OverviewReport)
